<div class="usa-logo">
  <div class="plants-logo">
    <a href="https://www.nrcs.usda.gov/" target="_blank" rel="noopener noreferrer">
      <img src="assets/img/usda-logo-color.svg" alt="USDA logo" />
    </a>
    <div class="plants-logo-text">
      <h1>Natural Resources Conservation Service</h1>
      <span>U.S. DEPARTMENT OF AGRICULTURE</span>
    </div>
  </div>
</div>
